// src/lib/tara/taraChatAnimationEngine.ts

export type TaraAnimMode = 'initial' | 'compact' | 'headerOnly';

/**
 * Variable-driven layout engine for Tara chat.
 * - 'initial': full layout (header + footer visible, normal paddings/sizes)
 * - 'compact': hide header/footer, compact paddings/sizes, widen chat
 * - 'headerOnly': reveal only the header while keeping compact layout elsewhere
 */
export default function taraChatAnimationEngine(
  mode: TaraAnimMode,
  isSidebarMinimized: boolean
) {
  const root = document.documentElement;

  if (mode === 'compact') {
    root.style.setProperty('--header-margin-top', '-8rem');
    root.style.setProperty('--main-container-padding-top', '1rem');

    root.style.setProperty('--tara-chat-container-height', '-3rem');
    root.style.setProperty('--tara-chat-margin-bottom', '10rem');
    root.style.setProperty('--tara-chat-padding-bottom', '0rem');

    if (isSidebarMinimized) {
      // Apply additional styles when the sidebar is minimized
      root.style.setProperty('--tara-chat-container-width', '85rem');
      root.style.setProperty('--tara-chat-input-width', '85rem');
    } else {
      root.style.setProperty('--tara-chat-container-width', '75rem');
      root.style.setProperty('--tara-chat-input-width', '75rem');
    }

    // Footer hidden in compact
    root.style.setProperty('--footer-display', 'none');
    return;
  }

  if (mode === 'headerOnly') {
    // Only reveal header paddings; keep compact chat/footer settings intact
    root.style.setProperty('--header-margin-top', '0rem');
    root.style.setProperty('--main-container-padding-top', '6rem');
    root.style.setProperty('--tara-chat-container-height', '1.5rem');
    
    // Footer should remain hidden when header is auto-hidden
    root.style.setProperty('--footer-display', 'none');

    return;
  }

  // 'initial' (default/full)
  root.style.setProperty('--header-margin-top', '0rem');
  root.style.setProperty('--main-container-padding-top', '10rem');
  root.style.setProperty('--tara-chat-container-height', '12rem');
  root.style.setProperty('--tara-chat-container-width', '75rem');
  root.style.setProperty('--tara-chat-input-width', '75rem');
  root.style.setProperty('--tara-chat-margin-bottom', '0rem');
  root.style.setProperty('--tara-chat-padding-bottom', '12rem');
  root.style.setProperty('--footer-display', 'block');
}
